export default "__VITE_ASSET__Dd98IKRF__"